export const isSmallScreen = (): boolean => window.innerWidth < 992;
